module.exports = __webpack_public_path__ + "img/moon.54d796e5.svg";